/* Salvona — swap Horizon's plain dropdown lists for rich panels (desktop header only), and add contact details to the phone menu */
(function(){
  var MAP=[['/pages/technology','svm-tech'],['/blogs/','svm-insights'],['/pages/about-us','svm-about']];
  function drawer(){
    var nav=document.querySelector('.menu-drawer__navigation'); var tpl=document.getElementById('svm-drawer');
    if(!nav||!tpl||document.querySelector('.svm-drawer-contact')) return;
    nav.parentNode.insertBefore(tpl.content.cloneNode(true),nav.nextSibling);
  }
  function run(){
    drawer();
    document.querySelectorAll('.menu-list__list-item').forEach(function(li){
      var top=li.querySelector(':scope > a, :scope > button, .menu-list__link');
      var href=top&&(top.getAttribute('href')||'');
      MAP.forEach(function(m){
        if(href.indexOf(m[0])!==0) return;
        var tpl=document.getElementById(m[1]); var grid=li.querySelector('.mega-menu__grid');
        if(!tpl||!grid||grid.dataset.svm) return;
        grid.dataset.svm='1'; grid.classList.add('svm-grid'); grid.innerHTML='';
        grid.appendChild(tpl.content.cloneNode(true));
        grid.querySelectorAll('[data-svm-text]').forEach(function(el){if(el.textContent.normalize)el.textContent=el.textContent.normalize('NFKC');});
      });
    });
  }
  if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
  /* the theme can rebuild the header menu after load (e.g. when fitting items), so re-apply when needed */
  window.addEventListener('load',run);
  document.addEventListener('pointerover',function(e){if(e.target.closest&&e.target.closest('.menu-list__list-item'))run();},{passive:true});
  document.addEventListener('focusin',function(e){if(e.target.closest&&e.target.closest('.menu-list__list-item'))run();});
  document.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('.header__icon--menu'))drawer();});
  document.addEventListener('shopify:section:load',run);

  /* Touch: the first tap on a top-level item opens its panel, the second follows its link, a tap elsewhere closes it.
     Horizon's hover handlers would open and close the panel within one tap, so they are skipped for touch only. Mouse and keyboard are unchanged. */
  var lastPointer='', tapped=null;
  window.addEventListener('pointerdown',function(e){lastPointer=e.pointerType;},{capture:true,passive:true});
  ['pointerenter','pointerleave'].forEach(function(type){
    window.addEventListener(type,function(e){
      if(e.pointerType==='touch'&&e.target.closest&&e.target.closest('.menu-list__list-item'))e.stopImmediatePropagation();
    },true);
  });
  function disclosure(li){return li&&li.querySelector('[ref="disclosure[]"]');}
  function closeTapped(){
    var d=disclosure(tapped); tapped=null;
    if(d&&d.getAttribute('aria-expanded')==='true')d.click();
  }
  document.addEventListener('click',function(e){
    if(lastPointer!=='touch'||!e.target.closest)return;
    var li=e.target.closest('.menu-list__list-item');
    var link=e.target.closest('[ref="menuitem"]');
    if(li&&link){
      var d=disclosure(li);
      if(!d||tapped===li)return;
      e.preventDefault(); run(); tapped=li;
      if(d.getAttribute('aria-expanded')!=='true')d.click();
      return;
    }
    if(tapped&&!(li&&li===tapped)&&!e.target.closest('[ref="disclosure[]"]'))closeTapped();
  },true);

  /* Header search suggestions use the exact-first rules in snippets/sv-search-words.liquid. */
  var nativeFetch=window.fetch;
  window.fetch=function(input,init){
    try{
      if(window.svSearch&&(typeof input==='string'||input instanceof URL)){
        var url=new URL(String(input),location.origin);
        var term=url.pathname.indexOf('/search/suggest')>-1&&url.searchParams.get('q');
        if(term&&term.trim()&&term.indexOf('"')<0){
          url.searchParams.set('q',window.svSearch.suggest(term));
          input=url.toString();
        }
      }
    }catch(e){}
    return nativeFetch.call(this,input,init);
  };
})();
